<div  class="container-fluid container-background">

  <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-4 bgwhite">

      <div class="outer">
      <div class="middle">
          <div class="login-form-container">
              <div class="login-header-title">
                  <i  class="zmdi zmdi-lock zdmi-fw"></i> Your account has been closed.
              </div>
              <span (click)="openContactSupport()" class="syncblue showhand" id="acct-status-contact-support">Contact Sync customer service</span> for further assistance.
          </div>

      </div> <!-- middle -->
      </div> <!-- outer -->
      </div>
      <div class="hidden-xs col-sm-6 col-md-7 col-lg-7 col-xl-8">
      </div>
  </div>
  </div>
